import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { OrganizationClaimsChangeDto } from '../entities/organization-user-dto';
import { ParentApiService } from './parent-api-service';

@Injectable({ providedIn: 'root' })
export class OrganizationClaimApiService extends ParentApiService {
  private readonly baseUrl = `${environment.webApiAddress}/api/claim`;

  constructor(private readonly http: HttpClient) {
    super();
  }

  setOrganizationClaims(dto: OrganizationClaimsChangeDto, stayOnPageIfError?: boolean): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/organization-claims`, dto, {
      headers: this.headersFor(stayOnPageIfError),
    });
  }

  handOverLeadAdmin(userId: string, stayOnPageIfError?: boolean): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/organization-lead-admin/hand-over?user-id=${userId}`, null, {
      headers: this.headersFor(stayOnPageIfError),
    });
  }
}
